<div class="ressource-dialog">
    <mat-toolbar class="mat-accent m-0 dialog-header">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title">{{ 'ressources.Ressource' | transloco }}</span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="resource-dialog-content">
        <form
            name="RessourceForm"
            [formGroup]="RessourceForm"
            autocomplete="off"
            class="event-form w-100-p"
            fxLayout="column"
            fxFlex
        >
            <mat-form-field class="w-100-p" floatLabel="always" appearance="outline">
                <input
                (keyup.enter)="!RessourceForm.invalid &&_matDialogRef.close(RessourceForm.getRawValue())"
                    autocomplete="off"
                    matInput
                    formControlName="label"
                    placeholder="{{'ressources.nom' | transloco}}"
                    *accessControl="{ permissions: administrationPermissions[this.add ? 'add-resource' : 'edit-resource']}"
                    required
                />
            </mat-form-field>
            <mat-checkbox *accessControl="{ permissions: administrationPermissions[this.add ? 'add-resource' : 'edit-resource']}" (change)="hi()" [checked]="checked"
                >{{ 'ressources.Sous_Ressource' | transloco }}</mat-checkbox
            >
            <div
                class="parent-select-field"
                fxFlex="1 0 auto"
                fxLayout="column"
                fxLayout.gt-xs="row"
                *ngIf="check"
            >
                <mat-form-field class="w-100-p" floatLabel="always" appearance="outline">
                    <mat-label>{{ 'ressources.ressource_parent' | transloco }}</mat-label>
                    <mat-select *accessControl="{ permissions: administrationPermissions[this.add ? 'add-resource' : 'edit-resource']}" formControlName="ressourceid">
                        <mat-option
                            *ngFor="let ressource of ressources"
                            [value]="ressource.id"
                        >
                            {{ ressource.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div
        mat-dialog-actions
        class="basic-dialog-actions"
        fxLayout="row"
        fxLayoutAlign="end center"
        *ngIf="add"
    >
        <button mat-button (click)="_matDialogRef.close()">
            {{ 'ressources.Annuler' | transloco }}
        </button>
        <button
            mat-flat-button
            color="primary"
            class="save-button mat-accent"
            aria-label="SAVE"
            [disabled]="RessourceForm.invalid"
            (click)="_matDialogRef.close(RessourceForm.getRawValue())"
        >
           {{ 'ressources.ajouter' | transloco }}
        </button>
    </div>
    <div
        mat-dialog-actions
        class="basic-dialog-actions"
        fxLayout="row"
        fxLayoutAlign="end center"
        *ngIf="!add"
    >
        <button mat-button (click)="_matDialogRef.close()">
        {{ 'ressources.Annuler' | transloco }}
    </button>

    <button
        mat-flat-button
        color="primary"
        aria-label="SAVE"
        [disabled]="RessourceForm.invalid"
        (click)="save()"
        *accessControl="{ permissions: administrationPermissions[this.add ? 'add-resource' : 'edit-resource']}"
    >
        {{ 'ressources.Sauvegarder' | transloco }}
    </button>
    </div>
</div>
 
